const API_BASE = 'https://new.sbdemolition.online/api/hr';

export const hrAPI = {
  // جيب إحصائيات الـ HR Dashboard
  getDashboardStats: async () => {
    const res = await fetch(`${API_BASE}/dashboard-stats.php`, {
      credentials: 'include',
    });
    return res.json();
  },

  // ✅ جيب آخر الأنشطة
  getRecentActivity: async (limit = 10) => {
    const res = await fetch(`${API_BASE}/recent-activity.php?limit=${limit}`, {
      credentials: 'include',
    });
    return res.json();
  },
};
